<template>
    <section id="step-4">
        <div class="row">
            <form
                class="col-lg-8"
                method="POST"
                :action="cartStore()"
            >
                <FormFields/>
                <h1>{{ $t('Order summarization') }}</h1>
                <div class="listing">
                    <OrderData/>
                </div>
                <Summary>
                    <h3>{{ $t('Summary') }}</h3>
                </Summary>
                <div class="pagination">
                    <PaginationButton type="prev" :text="$t('Delivery data')"/>
                    <button type="submit" class="next">
                        {{ $t('Must order') }}
                        <span class="arrow">&#8594;</span>
                    </button>
                </div>
                <div class="hidden-md-up">
                    <Help />
                </div>
            </form>
            <div class="col-lg-4 hidden-md-down">
                <Help/>
            </div>
        </div>
    </section>
</template>
<script>
import useCart from "../useCart";
import Summary from "../Partials/Summary";
import PaginationButton from "../Partials/PaginationButton";
import Help from "../Partials/Help";
import OrderData from "../Partials/OrderData";
import FormFields from "../Partials/FormFields";
import useRoutes from "../../../useRoutes";

export default {
    components: {
        FormFields,
        OrderData,
        PaginationButton,
        Summary,
        Help,
    },
    created() {
        this.updateCartStep(4)
    },
    setup() {
        const {
            updateCartStep,
        } = useCart()
        const {
            cartStore
        } = useRoutes()

        return {
            cartStore,
            updateCartStep,
        }
    },
}
</script>
